import { MappedClass, MappedProperty } from '@h5s/util-object';
import { ZPrinterVatType } from './z-printer-vat-type';

@MappedClass()
export class ZPrinterVatTypeApplicable {
  @MappedProperty()
  is_applicable: boolean;

  @MappedProperty()
  read_only: boolean;

  @MappedProperty()
  value: ZPrinterVatType;
}
